import React, {FC} from "react";
import Button from "@mui/material/Button";
import {CheckOutlined} from "@mui/icons-material";
import {Theme} from "@mui/material";
import Grid from "@mui/material/Grid";
import {WishType} from "../../../store/wish/Helper";
import {useTranslation} from "react-i18next";
import {SxProps} from "@mui/system";

interface IProps {
    value: WishType | undefined
    handleChange: (value: WishType | undefined) => void
    plural?: boolean
    color?: "primary" | "secondary"
    sx?: SxProps<Theme>
    all?: boolean
}

const WishTypePicker: FC<IProps> = ({color = "secondary", plural = true, all = false, ...props}) => {
    const {t} = useTranslation()

    const typeOptions = [
        {label: plural ? t('draws') : t('draw'), value: WishType.DRAW},
        {label: plural ? t('vouchers') : t('voucher'), value: WishType.VOUCHER},
    ]

    return (
        <Grid container gap={1} sx={props.sx}>
            {all && <Button
                endIcon={
                    undefined === props.value ? <CheckOutlined/> : undefined
                }
                color={color}
                variant={undefined === props.value ? 'contained' : "outlined"}
                onClick={() => props.handleChange(undefined)}
            >
                {t('all')}
            </Button>}
            {typeOptions.map(o => (
                <Button
                    key={o.value}
                    endIcon={
                        o.value === props.value ? <CheckOutlined/> : undefined
                    }
                    color={color}
                    variant={o.value === props.value ? 'contained' : "outlined"}
                    onClick={() => props.handleChange(o.value)}
                >
                    {o.label}
                </Button>
            ))}
        </Grid>
    )
}

export default WishTypePicker